import { render, staticRenderFns } from "./msg-icon.vue?vue&type=template&id=5e288f2a&scoped=true&"
import script from "./msg-icon.vue?vue&type=script&lang=js&"
export * from "./msg-icon.vue?vue&type=script&lang=js&"
import style0 from "./msg-icon.vue?vue&type=style&index=0&id=5e288f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e288f2a",
  null
  
)

export default component.exports